import CCMRTrackingStudent from './CCMRTrackingStudent.component';

export default CCMRTrackingStudent;
